/* unplugin-vue-components disabled */import script from "./TravelTable2.vue?vue&type=script&setup=true&lang=js"
export * from "./TravelTable2.vue?vue&type=script&setup=true&lang=js"

import "./TravelTable2.vue?vue&type=style&index=0&id=547aaacd&lang=css"

const __exports__ = script;

export default __exports__